import { z } from 'zod';

import type { DisplayContainerConfig } from '../../components/Support/DisplayContainer/DisplayContainer';

interface SelectedValue extends MakeModelValue {
  label: string;
}

export type MakeModelKeywordSearchProps = {
  value: string;
  makes: Array<MakeModelOption>;
  modalDisplayConfig: DisplayContainerConfig;
  dropdownDisplayConfig: DisplayContainerConfig;
  page: 'hp' | null;
  onSelectOption: (value: SelectedValue) => void;
} & Filters;

export type Filters = {
  maxPrice?: string;
  minPrice?: string;
  maxYear?: string;
  minYear?: string;
};

export type MakeModelOption = {
  value: MakeModelValue | null;
  label: string;
  count: string | null;
  groupLabel?: string;
};

export type MakeModelValue = {
  make?: string;
  model?: string;
};

const makeModelResponseOption = z.object({
  keyValues: z.object({
    make: z.string(),
    model: z.string().optional(),
  }),
  displayName: z.string(),
  count: z.number(),
});

export const responseSchema = z.object({
  filterValues: z.array(makeModelResponseOption),
});

export type MakeModelAutocompleteResponse = z.infer<typeof responseSchema>;

/**
 * Describes how the user interacts with the component for tracking purposes
 */
export const SEARCH_TYPES = {
  list: 'list',
  keyboard: 'keyboard',
} as const;

export type SearchTypes = keyof typeof SEARCH_TYPES;
